import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import axiosBaseURL from "..";

// export const useAuth = () => {
//     return useQuery({
//         queryKey: ['auth'],
//         staleTime: 120,
//         queryFn: async () => {
//             const result = await supabase.auth.getSession();

//             return result;
//         },
//     });
// }

// export const useSignIn = async () => {
//     return useMutation({
//         mutationFn: async ({ email, password }: { email: string, password: string }) => {
//             const status = await supabase.from('profiles').select('status').eq('email', email).single();

//             if (status.data?.status === 'INACTIVE') {
//                 return null;
//             }

//             const result = await supabase.auth.signUp({ email, password });

//             if (result.error) {
//                 throw new Error(result.error.message);
//             }

//             return result;
//         }
//     })
// }

// export const useSignUp = async () => {
//     return useMutation({
//         mutationFn: async ({ email, password }: { email: string, password: string, }) => {
//             const result = await supabase.auth.signUp({ email, password, });

//             if (result.error) {
//                 throw new Error(result.error.message);
//             }

//             return result;
//         }
//     })
// }

export const useCreateUser = () => {
  const { user } = useAuth() as AuthContextValue;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: {
      orgId: string;
      role: string;
      fullName: string;
      username: string;
      phoneNo: string;
      email: string;
      bankAccount: string;
    }) => {
      const result = await axiosBaseURL.post(
        `/users/create`,
        { id: null, organization: null, ...data },
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        }
      );

      return result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["useWarehouseList"] });
    },
  });
};

// export const useSignOut = () => {
//     return useMutation({
//         mutationFn: async () => {
//             const result = await supabase.auth.signOut();

//             if (result.error) {
//                 throw new Error(result.error.message);
//             }

//             return result;
//         }
//     })
// }

// export const useSendResetPasswordLink = () => {
//     return useMutation({
//         mutationFn: async (email: string) => {
//             const result = await supabase.auth.resetPasswordForEmail(email, {
//                 redirectTo: `http://localhost:3000/changePassword`,
//             },)

//             return result;
//         }
//     });
// }

// export const useSendResetPasswordLinkToOther = () => {
//     return useMutation({
//         mutationFn: async (email: string) => {
//             const result = await supabase.auth.resetPasswordForEmail(email, {
//                 redirectTo: `http://localhost:3000/resetPassword`,
//             },)

//             return result;
//         }
//     });
// }

export const useChangePassword = () => {
  const { user } = useAuth() as AuthContextValue;

  return useMutation({
    mutationFn: async (password: string) => {
      const result = await axiosBaseURL.post(
        `/fe/changePassword`,
        {
          userName: user?.userName,
          newPassword: password,
        },
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        }
      );

      return result;
    },
  });
};

// export const useResetPassword = () => {
//     const { mutateAsync: signOut } = useSignOut();
//     return useMutation({
//         mutationFn: async (data: { accessToken: string, refreshToken: string, password: string }) => {
//             const _result = await supabase.auth.setSession({
//                 access_token: data.accessToken,
//                 refresh_token: data.refreshToken,
//             });

//             if (_result.error) {
//                 return null;
//             }

//             const result = await supabase.auth.updateUser({ password: data.password });

//             signOut();
//             return result
//         }
//     })
// }
// export default useSignIn
